var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAlertFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M.134 15.503 8.149 1.514a1 1 0 0 1 1.735 0l8.015 13.989A1 1 0 0 1 17.03 17H1.001a1 1 0 0 1-.867-1.497ZM9.016 5.219a1 1 0 0 1 1 1V10a1 1 0 0 1-2 0V6.219a1 1 0 0 1 1-1ZM10.266 14a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z",
  clipRule: "evenodd"
})));
export default SvgIconAlertFilled;